/* eslint-disable max-nested-callbacks */
import { withStyles } from '@mui/styles';
import React, { useRef, useContext } from 'react';
import BreadCrumb from '../../../../components/molecules/BreadCrumb';
import PartnerSubTitleCard from '../../../../components/molecules/PartnerSubTitleCard';
import Filters from '../../components/Filters';
import SearchBox from '../../components/SearchBox';
import Button from '../../../../components/inputs/Button';
import Loader from '../../../../components/atoms/Loader';
import NotFound from '../../../../components/atoms/NotFound';
import TableGrid from '../../components/TableGrid/TableGrid';
import '../../../../features/assessments/screens/AssessmentContainer/customCss.css';
import SnackbarToast from '../../../../components/organisms/SnackbarToast';
import {
  ADD_DATA,
  ADD_DOCUMENT,
  DEFAULT_NULL_REPLACEMENT,
  LOADING_TEXT_FOR_REUSABLE_COMPONENTS,
  NUMBER_OF_RECORDS_PER_PAGE,
  SELF_REPORTING_DATA_SOURCE_LABELS,
  FAVOURITES_KEY_NAMES,
  SNACKBAR_TYPE,
  SUPPORT_ENTRY_OBJ,
} from '../../../../utils/constants';
import withRouter from '../../../../components/withRoute';
import { useEffect } from 'react';
import { useState } from 'react';
import {
  arrayOfObjectIntoObject,
  calculateDateFilterTimeStamp,
  checkOneTimeUser,
  firstLetterLowerCase,
  formatForTableGrid,
  convertToValueAndDateTableFormat,
  getAnalyticsEventsForRouteName,
  getBreadCrumbs,
  getConsentUserDetailsFromLocalStorage,
  getPartnerInfoConsolidated,
  getValueFromSourceList,
  getValueObjFromExtension,
  handleAddSelfReportedButtonalyticalEvents,
  viewDetailsDataFormatter,
  dateParse_appointment,
  APPOINTMENT_SCHEDULE_DETAILS,
  prior_authorization_records,
  prior_authorization_view_details,
  formatViewDetails,
} from '../../../../utils/helper';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useClickFooter from '../../../../hooks/useClickFooter';
import useWidth from '../../../../hooks/useWidth';
import useGetScreenMode from '../../../../hooks/useGetScreenMode';
import useUpdateUsedService from '../../../../hooks/useUpdateUsedService';
import useAnalyticsLogger from '../../../../hooks/useAnalyticsLogger';
import { useInitialLoading } from '../../../../hooks/useInitialLoading';
import { useLayoutEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { SELF_REPORTING_TEXTS } from '../../../../utils/constants';
import { useMemo } from 'react';
import ViewDetailsFlyout from '../../components/ViewDetailsFlyout/ViewDetailsFlyout';
import GenericServices from '../../Services/GenericServices';
import { useSelector } from 'react-redux';
import { mockTemplates } from '../../mockTemplate';
import CareTeamDetails from '../../components/viewDetailsCustomComponents/CareTeamDetails/CareTeamDetails';
import ReadingsBanner from '../../components/ReadingsBanner';
import ListItems from '../../components/ListItems';
import ProfileAssociateDetails from '../../components/ProfileAssociateDetails';
import ValueAndDateTable from '../../components/ValueAndDateTable';
import { getBgColorForInitials } from '../../../../pages/AwardPoints/GiftAwardPoints/helper';
import GenericDosageList from '../../components/GenericDosageList';
import CustomDateFilter from '../../../../pages/Visits/datePicker';
import { ViewAssessment, CloseIcon } from '@premkumarmph/assessment-library';
import { getAssessmentSubmissionResponse } from '../../../assessments/api';
import useFavouritesHook from '../../../../hooks/useFavouritesHook';
import { UserInfoContext } from '../../../../components/Routes';
import FileUploadModal from '../../../../pages/FileUploadModal';
import { getMemberSupportCases } from '../../../../pages/Support/api';
import PillOptionList from '../../../../pages/Support/PillOptionList';
import { Paper, Typography } from '@mui/material';
import colors from '../../../../utils/colors';
import { styled } from '@mui/material/styles';
import TotalCostSummary from '../../../../pages/TotalCostSummary';
// import useReadonly from '../../../../hooks/useReadonly';

const { MARK_RESTRICTED_DESC } = SELF_REPORTING_TEXTS;

const styles = (theme) => ({
  container: {
    background: '#F5F5F5',
    position: 'relative',
    minHeight: '100%',
    padding: '32px 32px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 16px',
    },
  },
  title: {
    fontSize: '28px',
    fontWeight: 600,
    height: '40px',
    marginTop: '24px',
    // marginBottom: '40px',
  },
  filterDropDownContainer: {
    display: 'flex',
    gap: '20px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px 0px',
      marginBottom: '8px',
    },
  },
  filtersContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  table_Wrapper: { marginTop: 16, position: 'relative' },
  // support_history only -- "All cases" / "Needs your action (N)" pill toggle above the
  // table (SUPPORT_REQUIREMENTS.md §11a). Reuses PillOptionList (pages/Support/
  // PillOptionList.js) rather than MUI Tabs, so it matches the app's own rounded-pill
  // segmented-control language already established elsewhere in Support (Appeal/Grievance's
  // Urgency/Clinical flag toggles) instead of looking like a generic, unstyled tab bar. The
  // count lives in the option's own label so it's visible regardless of which side is active.
  actionTabsRow: {
    marginTop: theme.spacing(2),
  },
  searchBoxRootClass: {},
  searchInputClass: {},
  filterContainerClass: {
    minWidth: '120px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  menu: {
    height: '40px',
    width: '40px',
    alignSelf: 'center',
  },
  favButtonContainer: {
    marginBottom: theme.spacing(2),
  },
  buttonsContainer: {
    display: 'flex',
  },
  spacer: {
    marginLeft: theme.spacing(2),
  },
  paperStyle: {
    padding: '16px 0px 0px 0px',
    width: '340px',
    height: '160px',
    borderRadius: '8px',
    boxSizing: 'border-box',
    alignItem: 'center',
    backgroundColor: colors.WHITE,
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
  },
  scheduletitle: {
    marginRight: '40px',
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    fontFamily: 'Inter',
    lineHeight: 1.6,
    color: colors.BLACK,
  },
  button: {
    width: 'max-content',
    padding: '8px 24px 8px 24px',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 500,
    marginTop: '12px',
    marginBottom: '16px',
    borderRadius: '40px',
    textTransform: 'none',
    border: '1px solid',
    color: colors.BLUE,
    borderColor: colors.SUBTLE_GRAY,
    '&:hover': {
      backgroundColor: colors.BLUE_HOVER,
      color: 'white',
    },
  },
});

const Img = styled('img')({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  width: '100%',
  height: '100%',
  maxWidth: '120px',
  maxHeight: '120px',
  marginLeft: '-10px',
  objectFit: 'contain',
  alignSelf: 'flex-end',
});

////////////////////////Below codes should be removed once BE sends formated data
const formatedData = (list) => {
  return list?.map((item, idx) => {
    // New flat assessment format (assessmentSubmissionId at top level)
    if (item?.assessmentSubmissionId !== undefined) {
      const flatStatus = (item?.status || '').toUpperCase();
      return {
        ...item,
        // Required by TableGrid isButtonDisabled logic for EXPIRED assessments
        assessmentResponse: {
          assessmentDisplay: {
            isAnswered: flatStatus === 'COMPLETED' || flatStatus === 'EXPIRED',
          },
        },
        extension: [
          { url: 'status', valueString: item?.status },
          { url: 'orgName', valueString: item?.orgName },
          { url: 'status_color', valueString: null },
        ],
      };
    }
    // Old nested assessment format
    return {
      ...item,
      extension: [
        { url: 'status', valueString: item?.assessmentResponse?.assessmentDisplay?.status },
        { url: 'orgName', valueString: item?.assessmentResponse?.assessmentMeta?.orgName },
        { url: 'status_color', valueString: item?.assessmentResponse?.assessmentDisplay?.statusColorCode },
      ],
    };
  });
};
///////////////////////////

const adaptSubmissionStepsForView = (steps, orgImageURL, status, orgName, assessmentName, completedDate) => ({
  url: orgImageURL,
  status,
  name: assessmentName,
  orgName,
  statusColorCode: null,
  completedDate: completedDate || null,
  assessmentDefinition: (steps || []).map((step) => {
    if ((step.type || '').toUpperCase() === 'QUESTION') {
      const q = step.question;
      return {
        id: q.questionId,
        type: 'standalone',
        title: q.title,
        answerType: q.questionType,
        answerId: q.answer?.selectedOptions?.map((o) => o.optionId) ?? [],
        answerValue: q.answer?.textValue || null,
        choices: q.options?.map((o) => ({ id: o.optionId, value: o.label })) ?? [],
        settings: { nextReferenceQuestion: [] },
        subQuestion: [],
      };
    }
    const g = step.group;
    return {
      id: g.groupId,
      type: 'group',
      title: g.groupName,
      answerId: [],
      answerValue: null,
      choices: [],
      settings: { nextReferenceQuestion: [] },
      subQuestion: (g.questions || []).map((q) => ({
        id: q.questionId,
        type: 'standalone',
        title: q.title,
        answerType: q.questionType,
        answerId: q.answer?.selectedOptions?.map((o) => o.optionId) ?? [],
        answerValue: q.answer?.textValue || null,
        choices: q.options?.map((o) => ({ id: o.optionId, value: o.label })) ?? [],
        settings: { nextReferenceQuestion: [] },
      })),
    };
  }),
});

const formatDate = (timestamp) => {
  if (!timestamp) return "N/A"; // Handle missing timestamps
  const date = new Date(timestamp);
  if (isNaN(date)) return "N/A"; // Handle invalid date objects
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ReusableCategoriesContainer = (props) => {
  const { classes, onFooterItemClick, navigate } = props;
  const location = useLocation();
  const { partner: partnerUrlParam, grantorId, granteeId, circleId, categoryName } = useParams();
  
  // Resources that use the new fetchAllRecordsData API instead of the legacy fetchAllRecords API
  const NEW_API_RESOURCES = ['condition', 'procedure', 'allergy', 'visits', 'immunization', 'social history', 'medication', 'family history', 'lab result', 'claim', 'coverages', 'appointments', 'assessments_dashboard'];
  
  const isOneTimeUser = checkOneTimeUser();
  const consentUserName = getConsentUserDetailsFromLocalStorage();
  const partnerInfo = getPartnerInfoConsolidated(partnerUrlParam);
  const screenMode = useGetScreenMode();
  const screenWidth = useWidth();
  const scheduleNavigate = useNavigate();
  let SERVICE_TYPE = categoryName;
  useUpdateUsedService(SERVICE_TYPE, screenMode?.isCircle, partnerInfo && partnerInfo?.circleId);
  const isLarge = screenWidth === 'lg' || screenWidth === 'xl';

  ////used for footerItemClicked
  useClickFooter(onFooterItemClick);

  /////data state////

  const [responseData, setRenponseData] = useState([]);
  const [responseGrid, setResponseGrid] = useState({});
  // support_history only -- 'all' | 'action_required', see actionTabs/actionTab styles and
  // the render block above the table. A real, server-side filtered getMemberSupportCases
  // query (actionPendingFrom: 'MEMBER', confirmed by backend 2026-10-02 -- see
  // getSupportHistoryCases and SUPPORT_REQUIREMENTS.md §11a.4) drives this -- switching tabs
  // triggers a full refetch from page 0 (see the actionTab effect below), not a client-side
  // filter over whatever happened to already be loaded.
  const [actionTab, setActionTab] = useState('all');
  // Independent of which tab is active, so the pill label's count is always accurate -- see
  // the dedicated fetch effect below (a lightweight page=0/size=1 call, read only for
  // pagination.totalElements).
  const [actionRequiredTotal, setActionRequiredTotal] = useState(0);
  const [showAddDocument, setShowAddDocument] = useState(false);
  const [tableRefresh, setTableRefresh] = useState(false);

  const [favLoading, setFavLoading] = useState(false);
  const [isOpen, setIsOpen] = useState({
    successModalOpen: false,
    cancelModalOpen: false,
  });

  const { templates } = useSelector((state) => state.templates);

  const [markRestricted, setMarkRestricted] = useState(
    templates?.[SERVICE_TYPE]?.details?.detailsTable?.options?.markRestricted ||
      mockTemplates[SERVICE_TYPE]?.details?.detailsTable?.options?.markRestricted ||
      false,
  );

  //////////data fields from templates/////////////////
  const title = templates?.[SERVICE_TYPE]?.title || mockTemplates[SERVICE_TYPE]?.title || '-';
  const useResponseGrid =
    templates?.[SERVICE_TYPE]?.useResponseGrid ||
    mockTemplates[SERVICE_TYPE]?.useResponseGrid ||
    false;
  const disableButton =
    templates?.[SERVICE_TYPE]?.disableButton || mockTemplates[SERVICE_TYPE]?.disableButton || {};
  const icon = templates?.[SERVICE_TYPE]?.icon || mockTemplates[SERVICE_TYPE]?.icon || '-';
  const bgColorForInitial =
    templates?.[SERVICE_TYPE]?.bgColorForInitial ||
    mockTemplates[SERVICE_TYPE]?.bgColorForInitial ||
    '';
  const filters =
    templates?.[SERVICE_TYPE]?.dashboard?.filters ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.filters ||
    [];
  const search =
    templates?.[SERVICE_TYPE]?.dashboard?.search ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.search ||
    {};
  const { enabled } =
    templates?.[SERVICE_TYPE]?.dashboard?.selfReporting ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.selfReporting ||
    {};

  const { enabled: addDocumentEnabled } =
    templates?.[SERVICE_TYPE]?.dashboard?.addDocument ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.addDocument ||
    {};

  const tableHeadings =
    templates?.[SERVICE_TYPE]?.dashboard?.tableColumns ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.tableColumns ||
    [];
  const breadCrumbProperties =
    templates?.[SERVICE_TYPE]?.dashboard?.breadCrumbProperties ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.breadCrumbProperties;

  const reloadOnScroll =
    templates?.[SERVICE_TYPE]?.dashboard?.reloadOnScroll ||
    mockTemplates[SERVICE_TYPE]?.dashboard?.reloadOnScroll;

  const customCardForViewDetails =
    templates?.[SERVICE_TYPE]?.details?.customCardForViewDetails?.detailsTable ||
    mockTemplates[SERVICE_TYPE]?.details?.detailsTable?.customCardForViewDetails ||
    {};

  const resourceName =
    templates?.[SERVICE_TYPE]?.resourceName || mockTemplates[SERVICE_TYPE]?.resourceName;

  const loaderName =
    templates?.[SERVICE_TYPE]?.loadingText || mockTemplates[SERVICE_TYPE]?.loadingText;

  const loaderViewDetailsName =
    templates?.[SERVICE_TYPE]?.details?.loadingText ||
    mockTemplates[SERVICE_TYPE]?.details?.loadingText;

  const isHistoricalCardEnable =
    templates?.[SERVICE_TYPE]?.details?.detailsTable?.options?.isHistoricalCardEnable ||
    mockTemplates[SERVICE_TYPE]?.details?.detailsTable?.options?.isHistoricalCardEnable;

  const selfReportingTemplate =
    templates?.[SERVICE_TYPE]?.selfReportingSection ||
    mockTemplates[SERVICE_TYPE]?.selfReportingSection;

  const uploadDocumentTypes = templates?.documentCategories || mockTemplates?.documentCategories;

  const needToFormat =
    templates?.[SERVICE_TYPE]?.dashboard?.needToFormat ||
    mockTemplates?.[SERVICE_TYPE]?.dashboard?.needToFormat;

  const buttonDetail =
    templates?.[SERVICE_TYPE]?.details?.medicationRequest?.buttonDetails ||
    mockTemplates?.[SERVICE_TYPE]?.details?.medicationRequest?.buttonDetails;
  /////////Table Headings/////////////////////
  const getTableHeading = useMemo(() => {
    let tableHeading = tableHeadings.map((obj) =>
      obj.headerName === 'Data source' ? { ...obj, hide: partnerUrlParam ? true : false } : obj,
    );
    if (isOneTimeUser && !isLarge) {
      tableHeading = tableHeadings?.filter(
        (obj) =>
          !['Recorded on', 'Criticality', 'Data source', 'Severity', 'Category'].includes(
            obj.headerName,
          ),
      );
    }

    return tableHeading;
  }, [isLarge, SERVICE_TYPE]);

  

  const { userInfo, setUserInfo } = useContext(UserInfoContext);
  const { isFavourite, renderFavIcon } = useFavouritesHook(resourceName);

  //////////////////breadCrumbs///////////////
  const breadCrumbs = breadCrumbProperties
    ? breadCrumbProperties
    : getBreadCrumbs(title, screenMode, partnerInfo, consentUserName, isOneTimeUser);
  /////////////////Analytics Events//////////
  const isCirclesOrRecords = location.pathname.includes('circles');
  const { logAnalyticsEvent } = useAnalyticsLogger();
  const analyticsEvents = getAnalyticsEventsForRouteName(SERVICE_TYPE);

  ///////////////Loader related state///////////
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [buttonDetails, setButtonDetails] = useState(buttonDetail);
  const [isLoading, setIsLoading] = useState(true);
  const [loaderText, setLoaderText] = useState(LOADING_TEXT_FOR_REUSABLE_COMPONENTS(loaderName));
  const [loaderViewDetailsText, setLoaderViewDetailsText] = useState(
    LOADING_TEXT_FOR_REUSABLE_COMPONENTS(loaderViewDetailsName),
  );

  //flyout states
  const [modalData, setModalData] = useState([]);
  const [editData, setEditData] = useState({});
  const [modalTitle, setModalTitle] = useState('');
  const [showEditInModal, setShowEditInModal] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [markAsRestrictedInModal, setMarkAsRestrictedInModal] = useState(false);
  const [historicalRecordsParamsObj, setHistoricalRecordsParamsObj] = useState({});
  const [currentObj, setCurrentObj] = useState({});
  const [documents, setDocuments] = useState([]);
  const [editDataForFlyout, setEditDataForFlyout] = useState({});
  const [viewProfileData, setViewProfileData] = useState([]);
  const [nextPageId, setNextPageId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ appointmentId, setAppointmentId] = useState()
  const [customComponentProps, setCustomComponentProps] = useState({
    note: '',
    membersDetails: [],
    assoc_care_plan_Details: [],
    responseObj: [],
    resourceType: '',
  });

  //infinite scroll and filters and search states
  const [hasInfiniteScroll, setHasInfiniteScroll] = useState(true);
  const recordsPerPage = NUMBER_OF_RECORDS_PER_PAGE;
  const [initialRender, setInitialRender] = useInitialLoading();
  const pageNumber = useRef(1);
  const changeFiltersValue = useRef(true);
  const timeFilter = useRef(0);
  const typeFilter = useRef('');
  const statusFilter = useRef([]);
  const searchValue = useRef('');
  const [apiData, setAPIData] = useState();
  const params = useParams();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showpage, setShowPage] = useState(true);
  //snackbar states
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState(SNACKBAR_TYPE.SUCCESS);

  //navigation to add selfReported Data
  const handleAddSelfReportedData = () => {
    handleAddSelfReportedButtonalyticalEvents(logAnalyticsEvent, SERVICE_TYPE);
    props.navigate(`/records/new/${SERVICE_TYPE.toLowerCase()}/add`);
  };

  // Support history's list query is real (see Support/api.js's getMemberSupportCases) --
  // bypasses the generic fetchAllRecords/fetchAllRecordsData paths below entirely for this
  // one resource. `offset` here is already a 0-indexed page counter (see handlepageNumber
  // below), matching getMemberSupportCases's own page/size response shape one-for-one, so
  // it's passed straight through as `page` with no conversion. Unlike the old getSupportCases,
  // patientId is a single required string (not an array), and `status` is a single string
  // (not a list) -- only one status pill can be active at a time anyway.
  //
  // actionPendingFrom: 'MEMBER' is passed whenever the "Needs your action" tab (FR-49) is
  // active, confirmed by backend 2026-10-02 as the real server-side filter for this (mirrors
  // the partner-side REST API's own actionPendingFrom=MEMBER/actionPending=true precedents --
  // see SUPPORT_REQUIREMENTS.md §11a.4). This makes the response itself already correctly
  // filtered and paginated -- no client-side re-filtering needed, responseData is shown as-is
  // either way (see the dropped supportHistoryTableData/isRowActionPending below).
  const getSupportHistoryCases = async (offset) => {
    const statusValue = Array.isArray(statusFilter.current) ? statusFilter.current[0] : statusFilter.current;
    const status =
      statusValue && statusValue !== '' && statusValue.toLowerCase() !== 'all' ? statusValue.toUpperCase() : undefined;
    const response = await getMemberSupportCases({
      patientId: userInfo?.patientId,
      status,
      actionPendingFrom: actionTab === 'action_required' ? 'MEMBER' : undefined,
      page: offset,
      size: recordsPerPage,
    });
    const content = response?.content || [];

    return {
      recordList: JSON.stringify(content),
      nextPageId: response?.pagination?.hasNext ? 'has_more' : null,
    };
  };

  const getAllRecords = async (offset) => {
    if (SERVICE_TYPE === 'support_history') {
      return await getSupportHistoryCases(offset);
    }
    const variables = {
      initiatorId: granteeId ?? '',
      grantorId: grantorId ?? '',
      count: recordsPerPage.toString(),
      offset: offset,
      nextPageId: offset == 0 ? '' : nextPageId,
      sourceUrl: partnerUrlParam ? partnerInfo?.partnerSourceUrl : '',
      resourceType: useResponseGrid ? selfReportingTemplate?.resourceType : SERVICE_TYPE,
      filters: [
        { filterType: 'dateFilter', value: [String(timeFilter.current)] },
        { filterType: 'documentType', value: [String(typeFilter.current)] }, 
        { filterType: 'statusFilter', value: [String(statusFilter.current)] },
        { filterType: 'searchFilter', value: [String(searchValue.current)] },
        {
          filterType: 'timePeriod',
          value: 'ALL',
        },
        {
          filterType: 'eobType',
          value: 'all',
        },
      ],
    };

    // Transform variables for new fetchAllRecordsData API
    const getDataApiVariables = () => ({
      resourceType: variables.resourceType,
      dateFilter: timeFilter.current ? String(timeFilter.current) : '0',
      statusFilter: Array.isArray(statusFilter.current) ? statusFilter.current.filter(s => s && s !== '') : (statusFilter.current && statusFilter.current !== '' ? [String(statusFilter.current)] : []),
      offset: variables.offset,
      count: parseInt(variables.count),
      sourceUrl: variables.sourceUrl,
      searchFilter: searchValue.current && searchValue.current !== '' ? searchValue.current : '',
      initiatorId: variables.initiatorId,
      grantorId: variables.grantorId,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Use system's time zone
      demoUser: false, // Default value
    });
    
    const multipleResourceTypes =
      templates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes ||
      mockTemplates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes;
    if (multipleResourceTypes) {
      const res = await Promise.all(
        multipleResourceTypes.map((item) => {
          if (NEW_API_RESOURCES.includes(resourceName)) {
            // For these new data modeling resources, use the new request structure
            const dataApiVars = getDataApiVariables();
            dataApiVars.resourceType = item;
            return GenericServices.fetchAllRecordsData(dataApiVars);
          }
          return GenericServices.fetchAllRecords({ ...variables, resourceType: item });
        }),
      );
      return arrayOfObjectIntoObject(res);
    
    } else {
      if (NEW_API_RESOURCES.includes(resourceName)) {
        // For these new data modeling resources, use the new fetchAllRecordsData API
        return await GenericServices.fetchAllRecordsData(getDataApiVariables());
      }
      return await GenericServices.fetchAllRecords(variables);
    }
  };
  
  // Dummy prior auth data, shown until the API returns real records.
  const setPriorAuthDummyData = () => {
    setRenponseData(formatForTableGrid(prior_authorization_records, SERVICE_TYPE, [String(statusFilter.current)]));
    setAPIData(prior_authorization_view_details);
    setHasInfiniteScroll(false);
  };

  const updateUi = async (offset, checkForNewlyCreatedRecord = false, onDocUpload = false) => {
    try {
      setIsLoading(true);
      const response = await getAllRecords(offset);
      let recordList, nextPageId
      
      if (NEW_API_RESOURCES.includes(resourceName)) {
        recordList = response.recordList
        // For these resources, we don't have nextPageId, so we'll handle pagination differently
        nextPageId = response.totalElements > (offset + 1) * recordsPerPage ? 'has_more' : null
      } else {
        // Handle fetchAllRecords response structure
        recordList = response.recordList
        nextPageId = response.nextPageId
      }
      
      setNextPageId(nextPageId)
      if (nextPageId === null && SERVICE_TYPE !== 'assessments_dashboard') {
        setHasInfiniteScroll(false)
      }
      let parsedResult = [];
      const result = JSON.parse(recordList);
      // Only normalize for new data API resources
      if (NEW_API_RESOURCES.includes(resourceName)) {
        // Helper to extract the correct id field
        const getNormalizedId = (obj) => {
          return (
            obj.assessmentSubmissionId ||
            obj.assessmentId ||
            obj.conditionId ||
            obj.procedureId ||
            obj.allergyId ||
            obj.immunizationId ||
            obj.visitId ||
            obj.medicationId ||
            obj.socialHistoryId ||
            obj.claimNumber ||
            obj.memberCoverageId ||
            obj.id // fallback if already normalized
          );
        };
        parsedResult = result.map((obj) => ({ ...obj, id: getNormalizedId(obj) }));
      } else {
        result.forEach((obj) => parsedResult.push(obj));
      }
      ///Below line should be removed, once BE send formated data
      parsedResult = useResponseGrid ? formatedData(parsedResult) : parsedResult;
      if (checkForNewlyCreatedRecord) {
        if (createdObj?.id) {
          // check if createdObj exists in all records and add if not
          const ifNewlyCreatedObjExists = parsedResult?.find((obj) => obj.id === createdObj.id);
          if (!ifNewlyCreatedObjExists) {
            const originalResLength = parsedResult?.length;
            const poppedAry = originalResLength > 0 ? parsedResult?.splice(0, parsedResult?.length - 1) : [];
            parsedResult = [createdObj, ...poppedAry];
          }
        }
      }
      // support_history paginates (see getSupportHistoryCases above) -- apiData has to
      // accumulate across pages the same way responseData does below, or "View details" on an
      // earlier page's row would resolve against a later page's apiData once it loads.
      if (needToFormat) {
        if (SERVICE_TYPE === 'support_history') {
          setAPIData((prev) => (pageNumber.current === 1 ? parsedResult : [...(prev || []), ...parsedResult]));
        } else {
          setAPIData(parsedResult);
        }
      }

      // Convert timestamp to formatted date
      let dataWithFormattedDate = parsedResult.map((item) => ({
        ...item,
        documentResponse: item.documentResponse
          ? {
              ...item.documentResponse,
              updatedAt: item.documentResponse.updatedAt || item.documentResponse.createdAt
                ? formatDate(item.documentResponse.updatedAt || item.documentResponse.createdAt) // Use updatedAt or fallback to createdAt
                : "-", // Fallback value if both are missing
            }
          : item.documentResponse,
      }));

      // Apply conversion for family history
      if (resourceName === 'family history') {
        dataWithFormattedDate = dataWithFormattedDate.map(convertToValueAndDateTableFormat);
      }

      // Row `id`s need to stay unique across accumulated pages too (see formatForTableGrid's
      // support_history case) -- offset by however many rows are already loaded.
      const idOffset = SERVICE_TYPE === 'support_history' && pageNumber.current !== 1 ? responseData.length : 0;
      // support_history's status pill filter is applied server-side (see
      // getSupportHistoryCases's `status` variable above), so no statusFilters are passed
      // through here -- formatForTableGrid's own status filtering is for other resource types.
      const formattedData = needToFormat
        ? formatForTableGrid(dataWithFormattedDate, SERVICE_TYPE, undefined, idOffset)
        : dataWithFormattedDate;
      const data = formattedData;
      sessionStorage.setItem("formattedData", JSON.stringify(formattedData));
      if (pageNumber.current !== 1 && data?.length === 0) {
        setHasInfiniteScroll(false);
        return;
      } else if (data?.length === 0 && pageNumber.current === 1) {
        setHasInfiniteScroll(false);
        if (SERVICE_TYPE === 'prior_authorization') {
          setPriorAuthDummyData();
          return;
        }
        setRenponseData([]);
        return;
      } else if (changeFiltersValue.current && data?.length && pageNumber.current === 1) {
        changeFiltersValue.current = false;
        setRenponseData(data);
        return;
      } else if (!changeFiltersValue.current && data?.length && pageNumber.current !== 1) {
        setRenponseData((prevData) => [...prevData, ...data]);
        return;
      }
    } catch (error) {
      if (SERVICE_TYPE === 'prior_authorization') {
        setPriorAuthDummyData();
        return;
      }
      console.warn('Error in fetching list: ', error);
      setHasInfiniteScroll(false);
    } finally {
      setIsLoading(false);
    }
  };

  const { state: propsState } = location;
  useEffect(() => {
    if (propsState?.carePlanId) {
      viewDetailsHandler(propsState?.carePlanId);
    } else if (propsState?.careTeamId) {
      viewDetailsHandler(propsState?.careTeamId);
    }
  }, [propsState]);

  useEffect(() => {
    // support_history's getMemberSupportCases needs patientId -- UserInfoContext populates it
    // asynchronously (see Routes.js), so this mount-time effect can fire before it's ready.
    // Re-running once it lands (this is a no-op re-render for every other resource type)
    // avoids sending the query with a missing patientId.
    if (SERVICE_TYPE === 'support_history' && !userInfo?.patientId) {
      return;
    }
    updateUi(0);
    changeFiltersValue.current = true;
    pageNumber.current = 1;
    return () => {
      setOpenPopUp(false);
    };
  }, [SERVICE_TYPE, tableRefresh, isOpen.cancelModalOpen, userInfo?.patientId]);

  // support_history only -- keeps the "Needs your action" pill label accurate regardless of
  // which tab is currently showing, via a dedicated lightweight call (page=0/size=1, only
  // pagination.totalElements is read) rather than inferring a count from whatever the main
  // list happens to have loaded.
  useEffect(() => {
    if (SERVICE_TYPE !== 'support_history' || !userInfo?.patientId) {
      return undefined;
    }
    let isMounted = true;
    getMemberSupportCases({ patientId: userInfo.patientId, actionPendingFrom: 'MEMBER', page: 0, size: 1 })
      .then((response) => {
        if (isMounted) {
          setActionRequiredTotal(response?.pagination?.totalElements || 0);
        }
      })
      .catch(() => {
        if (isMounted) {
          setActionRequiredTotal(0);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [SERVICE_TYPE, userInfo?.patientId, tableRefresh]);

  // support_history only -- switching "All cases"/"Needs your action" now changes a real
  // server-side filter (getSupportHistoryCases' actionPendingFrom), so it needs a full
  // refetch from page 0, the same reset handleChangeFilter does for status/category/search.
  // Guarded to skip the very first render (actionTab's initial value) so mount doesn't fetch
  // twice -- the effect above/the main mount effect already cover the first load.
  const isFirstActionTabRender = useRef(true);
  useEffect(() => {
    if (isFirstActionTabRender.current) {
      isFirstActionTabRender.current = false;
      return;
    }
    if (SERVICE_TYPE !== 'support_history') {
      return;
    }
    changeFiltersValue.current = true;
    setHasInfiniteScroll(true);
    setInitialRender(true);
    pageNumber.current = 1;
    updateUi(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionTab]);

  const { state } = location;
  useEffect(() => {
    const drawerOpen = state && state.appointments;
    const appId = sessionStorage.getItem('appointmentid')

    if (drawerOpen === 'appointmentspopup') {
      setDrawerOpen(true);
      setAppointmentId(appId)
    }
  }, [state]);

  //Filters methods
  const handleChangeFilter = () => {
    changeFiltersValue.current = true;
    setHasInfiniteScroll(true);
    setInitialRender(true);
    pageNumber.current = 1;
    updateUi(0);
  };

  const handlepageNumber = () => {
    pageNumber.current += 1;
    const offsetValue = pageNumber.current - 1;
    updateUi(offsetValue);
  };

  const handleSearch = (value) => {
    if (value !== searchValue) {
      searchValue.current = value;
      handleChangeFilter();
    }
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    setNextPageId(null);
    switch (name) {
      case 'dateFilter':
        let dateValue = 0;
        if (!value) {
          dateValue = 0;
        } else if (typeof value === 'object') {
          const date = Date.parse(value);
          dateValue = date;
        } else {
          dateValue = calculateDateFilterTimeStamp(value);
        }
        timeFilter.current = dateValue;
        handleChangeFilter();
        break;
      case 'statusFilter':
        statusFilter.current = value;
        handleChangeFilter();
        break;
        case 'typeFilter':
          typeFilter.current = value.toLowerCase();
          handleChangeFilter();
          break;
        default:
        return;
    }
  };

  useEffect(() => {
    if (props.location.state) {
      setLoaderText(props.location.state.loaderText);
      setLoaderViewDetailsText(props.location.state.loaderViewDetailsText);
      setSnackbarMessage(props.location.state.message);
    }

    ///converting object to array and passing as object based on route and categories
    const listOfEvents = Object.entries(analyticsEvents)?.map(([key, value]) => value);
    isCirclesOrRecords
      ? logAnalyticsEvent(listOfEvents?.[0])
      : logAnalyticsEvent(listOfEvents?.[1]);
  }, []);

  const getViewDetailsCustomTemplates = {
    labs: {
      component: ReadingsBanner,
      props: { editDataForFlyout },
    },
  };
  const getCustomTemplates = {
    care_plan: {
      component: ListItems,
      props: {
        responseObj: customComponentProps?.responseObj,
      },
    },
    care_team: {
      component: ProfileAssociateDetails,
      props: {
        membersDetails: { memberList: customComponentProps.membersDetails, heading: 'Members' },
        assoc_care_plan_Details: {
          associatedPlansList: customComponentProps.assoc_care_plan_Details,
          heading: 'Associated care plans',
        },
        screenMode,
      },
    },
    family_member_history: {
      component: ValueAndDateTable,
      props: {
        conditions: customComponentProps?.responseObj?.condition || [],
        note: customComponentProps?.responseObj?.note || DEFAULT_NULL_REPLACEMENT,
        reasonForHistory: customComponentProps?.responseObj?.reasonCode || [],
      },
    },
    medications: {
      component: GenericDosageList,
      props: {
        dosageInstruction: customComponentProps?.responseObj?.dosageInstruction,
        note: customComponentProps?.responseObj?.note,
        resourceType: customComponentProps?.resourceType,
        responseObj: customComponentProps?.responseObj, // Add this for new API structure
      },
    },
  };

  const getMemberDetails = (memberList = []) => {
    const res = memberList.map(({ member, onBehalfOf, role }, index) => {
      return {
        id: index,
        member_name:
          typeof member === String ? member : member?.display || member?.identifier?.display || '',
        imgUrl: member?.avatarUrl || '',
        specialty: role?.[0]?.coding?.[0]?.display || DEFAULT_NULL_REPLACEMENT,
        partnerName: onBehalfOf?.display || DEFAULT_NULL_REPLACEMENT,
        bgColor: getBgColorForInitials(),
      };
    });
    return res;
  };
  const getAssociateCarePlanDetails = (associateCarePlanList = []) => {
    return associateCarePlanList?.map((associateDetails) => {
      const dailyExerciseList = associateDetails?.listElements;
      return {
        id: associateDetails?.resource_id,
        imgUrl: associateDetails?.iconurl || null,
        heading: associateDetails?.title,
        subHeading: associateDetails?.subtitle || 'Activities',
        list: dailyExerciseList,
        resource: associateDetails?.resource,
        resource_id: associateDetails.resource_id,
      };
    });
  };

  const markRestrictedFun = (resourceType) => {
    const markRestricted =
      templates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes ||
      mockTemplates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes
        ? templates?.[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.options
            ?.markRestricted ||
          mockTemplates?.[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.options
            ?.markRestricted
        : templates?.[SERVICE_TYPE]?.details?.detailsTable?.options?.markRestricted ||
          mockTemplates?.[SERVICE_TYPE]?.details?.detailsTable?.options?.markRestricted;
    setMarkRestricted(markRestricted);
  };

  const viewDetailsHandler = async (id, resource_Type) => {
    setModalData(null);
    setIsLoading(true);
    setDetailsLoading(true);
    setShowEditInModal(false);
    setLoaderViewDetailsText(
      LOADING_TEXT_FOR_REUSABLE_COMPONENTS(`${loaderViewDetailsName} details`),
    );
    SERVICE_TYPE = resource_Type ? resource_Type : SERVICE_TYPE
    const tableRowInfo = responseData.find((obj) => obj.id === id);
    const multiAPICalls =
      templates?.dashboard?.[SERVICE_TYPE]?.queryResourceTypes ||
      mockTemplates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes;
    const resourceType = firstLetterLowerCase(
      tableRowInfo?.resourceType,
      SERVICE_TYPE,
      multiAPICalls,
    );
    const buttonDetails =
      templates?.[SERVICE_TYPE]?.details?.[resourceType]?.buttonDetails ||
      mockTemplates?.[SERVICE_TYPE]?.details?.[resourceType]?.buttonDetails;
    markRestrictedFun(resourceType);
    setButtonDetails(buttonDetails);
    setCurrentObj(tableRowInfo);
    try {
      let resourceObj;
      let documentReferenceId = null;
      let docArn = null;
      
      if (NEW_API_RESOURCES.includes(resourceName)) {
        // For claims and coverages, make API call to get view details data
        if (resourceName === 'claim' || resourceName === 'coverages') {
          const resourceIdField = resourceName === 'claim' ? 'claimNumber' : 'memberCoverageId';
          const fetchResult = await GenericServices.fetchRecordsDataById({
            resourceType: SERVICE_TYPE,
            resourceId: tableRowInfo?.[resourceIdField]?.toString() ?? '',
          });
          
          // Parse the resource JSON string
          resourceObj = JSON.parse(fetchResult.resource);
          // Add the id from the response
          resourceObj.id = fetchResult.id;
        } else {
          // For other new data modeling resources, use the data directly from the table row
          resourceObj = tableRowInfo;
        }
      } else {
        // For other resources, use the existing fetchRecordById API
        const fetchResult = await GenericServices.fetchRecordById({
          resourceType: resource_Type ? resource_Type : resourceType,
          resourceId: id?.toString() ?? '',
          grantorId: grantorId?.toString() ?? '',
        });
        resourceObj = JSON.parse(fetchResult.record);
        documentReferenceId = fetchResult.documentReferenceId;
        docArn = fetchResult.docArn;
      }
      
      resourceObj = {
        ...resourceObj,
        docArn: docArn,
        documentReferenceId: documentReferenceId,
      };
      
      // Format attendees for appointments - keep the raw attendee objects for better display
      if (resourceName === 'appointments' && resourceObj.attendees) {
        resourceObj.attendeesFormatted = resourceObj.attendees;
      }
      
      setCustomComponentProps({
        responseObj: resourceObj,
        resourceType: resourceType,
        note: resourceObj?.note?.[0]?.text || '-',
        membersDetails:
          (resourceObj?.participant && getMemberDetails(resourceObj?.participant)) || [],
        assoc_care_plan_Details:
          (resourceObj?.extension &&
            getValueObjFromExtension(resourceObj?.extension, 'associated_data')?.valueString &&
            JSON.parse(
              getValueObjFromExtension(resourceObj?.extension, 'associated_data')?.valueString,
            ) &&
            getAssociateCarePlanDetails(
              JSON.parse(
                getValueObjFromExtension(resourceObj.extension, 'associated_data')?.valueString,
              ),
            )) ||
          [],
      });
      const viewProfileKey =
        templates?.[categoryName]?.details?.associatedData ||
        mockTemplates?.[categoryName]?.details?.associatedData;
      const viewProfile = viewProfileKey ? getValueFromSourceList(resourceObj, viewProfileKey) : [];
      setViewProfileData(
        typeof viewProfile === 'string' && viewProfile !== '-' ? JSON.parse(viewProfile) : [],
      );
      setDocuments(docArn);

      // For claims, determine if it's medical or pharmacy based on category
      let claimType = null;
      if (SERVICE_TYPE === 'claims') {
        const category = resourceObj?.category?.toLowerCase();
        claimType = category === 'pharmacy' ? 'pharmacy' : 'medical';
      }

      const detailsTemplate =
        templates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes ||
        mockTemplates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes
          ? templates?.[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.cols ||
            mockTemplates[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.cols ||
            {}
          : SERVICE_TYPE === 'claims' && claimType
          ? templates?.[SERVICE_TYPE]?.details?.[claimType]?.detailsTable?.cols ||
            mockTemplates[SERVICE_TYPE]?.details?.[claimType]?.detailsTable?.cols ||
            {}
          : templates?.[SERVICE_TYPE]?.details?.detailsTable?.cols ||
            mockTemplates[SERVICE_TYPE]?.details?.detailsTable?.cols ||
            {};
      const header =
        templates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes ||
        mockTemplates?.[SERVICE_TYPE]?.dashboard?.queryResourceTypes
          ? templates?.[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.header ||
            mockTemplates[SERVICE_TYPE]?.details?.[resourceType]?.detailsTable?.header ||
            DEFAULT_NULL_REPLACEMENT
          : SERVICE_TYPE === 'claims' && claimType
          ? templates?.[SERVICE_TYPE]?.details?.[claimType]?.detailsTable?.header ||
            mockTemplates[SERVICE_TYPE]?.details?.[claimType]?.detailsTable?.header ||
            DEFAULT_NULL_REPLACEMENT
          : templates?.[SERVICE_TYPE]?.details?.detailsTable?.header ||
            mockTemplates[SERVICE_TYPE]?.details?.detailsTable?.header ||
            DEFAULT_NULL_REPLACEMENT;
      const formattedData = viewDetailsDataFormatter(
        resourceObj,
        detailsTemplate,
        selfReportingTemplate,
        customCardForViewDetails,
        header,
        partnerUrlParam && true,
      );
      setModalData(formattedData?.modalData);
      setModalTitle(formattedData?.title);
      setMarkAsRestrictedInModal(formattedData?.markAsRestricted);
      //////for custom component in viewDetails flyout For lab Result
      setEditDataForFlyout(formattedData?.requiredPropsForCustomCardInViewDetails);
      ///////////////////////
      setHistoricalRecordsParamsObj({
        resourceType: resourceType ?? SERVICE_TYPE,
        icon: icon,
        title: formattedData?.title,
        partner: partnerUrlParam,
        circleId: partnerInfo?.circleId,
        code: formattedData?.code,
      });
      setOpenPopUp(true);

      setIsLoading(false);
      if (SELF_REPORTING_DATA_SOURCE_LABELS.includes(formattedData?.dataSource?.toLowerCase())) {
        setShowEditInModal(true);
        setEditData(formattedData?.editData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
      setDetailsLoading(false);
    }
  };

  const handleViewDetails = async (id) => {
    // support_history no longer uses the flyout at all -- "View details" now navigates to
    // the full-screen case page (same page "Action required" uses, see
    // handleActionRequiredClick below), landing at the top instead of scrolled down to the
    // info-requests section. That page re-fetches the case itself via the real
    // getMemberSupportCase query, so nothing needs pre-fetching here -- just hand it the
    // list row (apiData[id]) via router state the same way the page already expects, for
    // the summary-only fields (assignedToName/slaDueAt/receivedAt) getMemberSupportCase
    // alone doesn't return. See SUPPORT_REQUIREMENTS.md §11a.
    if (SERVICE_TYPE === 'support_history') {
      const listRow = apiData?.[id];
      if (listRow?.id) {
        props.navigate(`/utilities/support/support_history/${listRow.id}/details`, {
          state: { listRow },
        });
      }
      return;
    }

    setModalTitle(responseData?.[id]?.title);
    const data = formatViewDetails(apiData?.[id], SERVICE_TYPE);
    setModalData(data);
    setOpenPopUp(true);
  };

  // support_history only -- clicking the "Attach documents" button in the "Action required"
  // column (TableGrid's new actionRequiredButton column) jumps straight to the same
  // full-screen case page "View details" opens, but tells it to scroll straight down to the
  // info-requests section instead of landing at the top, since that's the one thing the
  // button is already telling the member to do.
  const handleActionRequiredClick = (id) => {
    const listRow = apiData?.[id];
    if (listRow?.id) {
      props.navigate(`/utilities/support/support_history/${listRow.id}/details`, {
        state: { listRow, scrollToInfoRequests: true },
      });
    }
  };

  const handleViewDetailsInAssessment = async (id, isOpenViewDetails) => {
    if (isOpenViewDetails) {
      setIsLoading(true);
      setLoaderViewDetailsText(
        LOADING_TEXT_FOR_REUSABLE_COMPONENTS(`${loaderViewDetailsName} details`),
      );

      try {
        // New assessments_dashboard: fetch full submission via new API
        if (SERVICE_TYPE === 'assessments_dashboard') {
          const tableRowInfo = responseData.find((obj) => obj.id === id) || {};
          const submissionId = tableRowInfo.assessmentSubmissionId;
          if (!submissionId) {
            setIsLoading(false);
            return;
          }
          const submissionSteps = await getAssessmentSubmissionResponse(submissionId);
          const displayAssessment = adaptSubmissionStepsForView(
            submissionSteps,
            tableRowInfo.orgImageURL,
            tableRowInfo.status,
            tableRowInfo.orgName,
            tableRowInfo.assessmentName,
            tableRowInfo.completedDate,
          );
          setResponseGrid(displayAssessment);
          setOpenPopUp(true);
          return;
        }

        let resourceObj;
        if (NEW_API_RESOURCES.includes(resourceName)) {
          // For these new data modeling resources, use the data directly from the table row instead of making fetchRecordById API call
          const tableRowInfo = responseData.find((obj) => obj.id === id);
          resourceObj = tableRowInfo || {};
        } else {
          // For other resources, use the existing fetchRecordById API
          const { record } = await GenericServices.fetchRecordById({
            resourceType: selfReportingTemplate?.resourceType,
            resourceId: id?.toString() ?? '',
            grantorId: grantorId?.toString() ?? '',
          });
          resourceObj = JSON.parse(record);
        }

        const handleAnswers = (subQ) => {
          return subQ?.answers
            ?.filter((subAnswer) => subAnswer?.answered && subAnswer?.question)
            .map((subAnswered) => subAnswered);
        };

        const handleAnsweredId = (question) => {
          return question?.answers
            ?.filter((answer) => answer.answered)
            .map((answered) => answered?.id);
        };

        const handleChoices = (question) => {
          return question?.answers?.map((answer) => ({
            ...answer,
            value: answer?.text || DEFAULT_NULL_REPLACEMENT,
          }));
        };

        const handleAnswerValue = (question) => {
          if (
            question?.answerType?.toLowerCase() === 'shorttext' ||
            question?.answerType?.toLowerCase() === 'longtext'
          ) {
            return question?.answers?.[0]?.answered === true
              ? question?.answers?.[0]?.answeredValue
              : DEFAULT_NULL_REPLACEMENT;
          }
          return handleAnsweredId(question)?.length === 0 ? DEFAULT_NULL_REPLACEMENT : null;
        };

        const handleNRQ = (question) => {
          const answeredIds = handleAnswers(question);
          const nrqQuestions = answeredIds?.map((nrqQuestion) => ({
            selectedChoice: nrqQuestion?.id,
            question: {
              ...nrqQuestion?.question,
              answerId: handleAnsweredId(nrqQuestion?.question),
              choices: handleChoices(nrqQuestion?.question),
              answerValue: handleAnswerValue(nrqQuestion?.question),
            },
          }));
          return nrqQuestions;
        };

        const displayAssessment = {
          url: resourceObj?.assessmentResponse?.assessmentMeta?.orgImageURL,
          status: resourceObj?.assessmentResponse?.assessmentMeta?.status,
          statusColorCode: resourceObj?.assessmentDisplay?.statusColorCode,
          completedDate: resourceObj?.assessmentDisplay?.completedDate,
          name: resourceObj?.assessmentResponse?.assessmentMeta?.assessmentName,
          assessmentDefinition:
            resourceObj?.assessmentResponse?.assessmentResponseBody?.assessmentQuestionnaires.map(
              (question) => ({
                ...question,
                subQuestion: question?.questions?.map((subQ) => ({
                  ...subQ,
                  answerId: handleAnsweredId(subQ),
                  choices: handleChoices(subQ),
                  answerValue: handleAnswerValue(subQ),
                  settings: {
                    nextReferenceQuestion: handleNRQ(subQ),
                  },
                })),
                answerId: handleAnsweredId(question),
                choices: handleChoices(question),
                answerValue: handleAnswerValue(question),
                settings: {
                  nextReferenceQuestion: handleNRQ(question),
                },
              }),
            ),
        };
        setResponseGrid(displayAssessment);
        setOpenPopUp(true);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    } else {
      // Navigate to assessment container
      if (SERVICE_TYPE === 'assessments_dashboard') {
        const currentAssessment = responseData?.find((item) => item.id === id) || {};
        navigate('/assessments', {
          state: {
            assessmentUuid: currentAssessment.assessmentId || currentAssessment.assessmentUuid, // Handle both old and new formats
            assessmentSubmissionId: currentAssessment.assessmentSubmissionId,
            status: currentAssessment.status,
            orgName: currentAssessment.orgName,
            orgImageURL: currentAssessment.orgImageURL,
            assessmentName: currentAssessment.assessmentName,
            patientId: userInfo?.patientId,
          },
        });
        return;
      }
      // Legacy path for old assessments format
      const currentAssessment = responseData?.find(
        (item) => item?.assessmentResponse?.assessmentMeta?.id === id,
      );
      navigate('/assessments', {
        state: { assessmentInstanceId: id, status: currentAssessment?.status },
      });
    }
  };

  const onEdit = ({ newRestrictedVal = markAsRestrictedInModal }) => {
    props.navigate(`/records/new/${SERVICE_TYPE.toLowerCase()}/edit`, {
      state: { editProps: editData, markAsRestricted: newRestrictedVal },
    });
  };

  useLayoutEffect(() => {
    if (partnerUrlParam && !partnerInfo?.partnerSourceUrl) {
      props.navigate('/circles');
    }
    return () => {
      // localStorage.removeItem('partnerInfo');
      if (onFooterItemClick) {
        onFooterItemClick(-1);
      }
    };
  }, []);

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const handleAddDocument = () => {
    setShowAddDocument(true);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onDocumentSave = () => {
    setShowAddDocument(false);
    setTableRefresh(!tableRefresh);
    setSnackbarType(SNACKBAR_TYPE.SUCCESS);
    setSnackbarMessage('Document uploaded successfully');
  };

  const claims = SERVICE_TYPE === 'claims';

  return (
    <div className={classes.container}>
      {initialRender && <Loader overlay text={loaderText} />}
      {detailsLoading && <Loader overlay text={loaderViewDetailsText} />}
      <BreadCrumb breadCrumbProps={breadCrumbs} />
      <h2 className={classes.title}>{title}</h2>
      {userInfo?.betaUser && FAVOURITES_KEY_NAMES[resourceName] && (
        <div className={classes.favButtonContainer}>{renderFavIcon()}</div>
      )}
      {partnerInfo?.partnerIconUrl && partnerUrlParam && (
        <PartnerSubTitleCard icon={partnerInfo?.partnerIconUrl} title={partnerUrlParam} />
      )}
      <div className={classes.filtersContainer}>
        <div className={classes.filterDropDownContainer}>
          {search.datePicker ? (
            <CustomDateFilter
              searchValue={searchValue.current}
              placeholder={search.placeholder}
              filterItem={search}
              handleChange={handleSearch}
            />
          ) : (
            <SearchBox
              search={search}
              handleSearch={handleSearch}
              searchBoxRootClass={classes.searchBoxRootClass}
              searchInputClass={classes.searchInputClass}
            />
          )}
          <Filters
            handleFilter={handleFilter}
            filters={filters}
            filterContainerClass={classes.filterContainerClass}
          />
          
        </div>

        <div className={classes.buttonsContainer}>
          {SERVICE_TYPE === 'support_history' && (
            <div className={classes.spacer}>
              <Button onClick={() => scheduleNavigate('/utilities/support')}>
                {SUPPORT_ENTRY_OBJ.CREATE_REQUEST_BUTTON}
              </Button>
            </div>
          )}

          {!screenMode?.isCircle && !screenMode?.involvesConsent && !isOneTimeUser && enabled && (
            <div className={classes.spacer}>
              <Button onClick={handleAddSelfReportedData}>{ADD_DATA}</Button>
            </div>
          )}

          {addDocumentEnabled && (
            <div className={classes.spacer}>
              <Button onClick={handleAddDocument}>{ADD_DOCUMENT}</Button>
            </div>
          )}
           {claims && userInfo?.betaUser && resourceName !== 'appointments' && (
            <div className={classes.spacer}>
              <Button onClick={openModal}>
                {'Total cost summary'}
              </Button>
            </div>
    
          )}
          {isModalOpen && <TotalCostSummary open={openModal} close={closeModal} onClose={closeModal} />}

          {userInfo?.betaUser && resourceName !== 'appointments' && (
            <div className={classes.spacer} style={{flexShrink: 0}}>
              <Button disabled={!!!responseData?.length} onClick={handlePrint}>
                {'Print'}
              </Button>
            </div>
          )}
        </div>
      </div>
      {SERVICE_TYPE === 'support_history' && (
        <div className={classes.actionTabsRow}>
          <PillOptionList
            ariaLabel="Filter support cases"
            options={[
              { value: 'all', label: 'All cases' },
              { value: 'action_required', label: `Needs your action (${actionRequiredTotal})` },
            ]}
            value={actionTab}
            onChange={setActionTab}
          />
        </div>
      )}
      <div className={classes.table_Wrapper}>
        {!responseData?.length && !isLoading && <NotFound title={title} />}
        {responseData?.length > 0 && (
          <TableGrid
            ref={printRef}
            setOpen={setOpenPopUp}
            data={responseData}
            serviceType={SERVICE_TYPE}
            viewDetailsData={modalData}
            customBodyComponent={getCustomTemplates[SERVICE_TYPE]}
            markAsRestricted={markAsRestrictedInModal}
            restrictedDescription={MARK_RESTRICTED_DESC(resourceName)}
            currentObj={currentObj}
            clinicalRecord={customComponentProps?.resourceType ?? SERVICE_TYPE}
            viewDetails
            selfReportingTemplate={selfReportingTemplate}
            paginationObj={{
              handlepageNumber: handlepageNumber,
              loading: isLoading,
              detailsLoading,
              hasInfiniteScroll: hasInfiniteScroll,
            }}
            tableHeading={getTableHeading}
            viewDetailsHandler={needToFormat ? handleViewDetails : viewDetailsHandler}
            actionRequiredClickHandler={SERVICE_TYPE === 'support_history' ? handleActionRequiredClick : undefined}
            screenMode={screenMode}
            useResponseGrid={useResponseGrid}
            handleViewDetailsInAssessment={handleViewDetailsInAssessment}
            disableButton={disableButton}
            onRefresh={() => setTableRefresh(!tableRefresh)}
            reloadOnScroll={reloadOnScroll}
            nextPageId={nextPageId}
          />
        )}
      </div>

      <FileUploadModal
        options={uploadDocumentTypes}
        show={showAddDocument}
        onClose={() => setShowAddDocument(false)}
        onSave={() => onDocumentSave()}
        onError={() => {}}
      />

      {openPopUp && resourceName !== 'care plan'  && !useResponseGrid && (
        <ViewDetailsFlyout
          setOpen={setOpenPopUp}
          data={modalData}
          markAsRestricted={markAsRestrictedInModal}
          title={modalTitle}
          currentObj={currentObj}
          documents={documents}
          clinicalRecord={customComponentProps?.resourceType ?? SERVICE_TYPE}
          icon={icon}
          bgColorForInitial={bgColorForInitial}
          isHistoricalCardEnable={isHistoricalCardEnable}
          markRestricted={markRestricted}
          historicalRecordsParamsObj={
            !screenMode?.involvesConsent ? historicalRecordsParamsObj : {}
          }
          showEdit={showEditInModal}
          restrictedDescription={MARK_RESTRICTED_DESC(resourceName)}
          handleEdit={(obj) => onEdit(obj)}
          hideOptions={Boolean(partnerUrlParam || grantorId)}
          //////////////custom component with props for new layouts above the key-value pair list
          customComponent={getViewDetailsCustomTemplates[SERVICE_TYPE]}
          customBodyComponent={getCustomTemplates[SERVICE_TYPE]}
          viewProfileData={viewProfileData}
          buttonDetails={buttonDetails}
        />
      )}
      {openPopUp && useResponseGrid && (
        <div>
          {/* {alert('viewDetails')} */}
          {/* AssessmentViewDetails with this props modalData={modalData} setOpenPopUp={setOpenPopUp} */}
          {/* onClick={(viewDetailsHandler)} */}
          <ViewAssessment
            dateField={responseGrid.completedDate}
            dateHeader="Completed on"
            getStatusColor={() => responseGrid.statusColorCode}
            data={responseGrid}
            handleClose={() => setOpenPopUp(false)}
            styles={{
              logo: { width: '100%', maxHeight: '48px', maxWidth: '200px', marginBottom: '8px' },
            }}
          />
        </div>
      )}
      <SnackbarToast
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={!!snackbarMessage}
        alertStyle={{ backgroundColor: '#1F1F1F', borderRadius: 4, color: '1F1F1F' }}
        duration={4000}
        onClose={() => {
          setSnackbarMessage(null);
        }}
        message={snackbarMessage}
        type={snackbarType}
      />
    </div>
  );
};

export default withRouter(withStyles(styles)(ReusableCategoriesContainer));
